import React from "react";

const ManageIcon = ({ isActive }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const fillColor = isActive ? "var(--color-primary)" : isHovered ? "var(--color-primary)" : "#969BA9";

  return (
    <span onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27" fill="none">
        <rect x="0.5" width="27" height="27" rx="5" fill={isActive ? "var(--color-primary)" : ""} />
        <path
          d="M9.15081 20.2504H10.9508C11.1992 20.2504 11.4008 20.0152 11.4008 19.7254V8.17539C11.4008 7.88559 11.1992 7.65039 10.9508 7.65039H9.15081C8.90241 7.65039 8.70081 7.88559 8.70081 8.17539V19.7254C8.70081 20.0152 8.90241 20.2504 9.15081 20.2504Z"
          fill={fillColor}
        />
        <path
          d="M13.2008 20.2504H15.0008C15.2492 20.2504 15.4508 20.0152 15.4508 19.7254V8.17539C15.4508 7.88559 15.2492 7.65039 15.0008 7.65039H13.2008C12.9524 7.65039 12.7508 7.88559 12.7508 8.17539V19.7254C12.7508 20.0152 12.9524 20.2504 13.2008 20.2504Z"
          fill={fillColor}
        />
        <path
          d="M19.0508 7.65039H17.2508C17.0024 7.65039 16.8008 7.88559 16.8008 8.17539V19.7254C16.8008 20.0152 17.0024 20.2504 17.2508 20.2504H19.0508C19.2992 20.2504 19.5008 20.0152 19.5008 19.7254V8.17539C19.5008 7.88559 19.2992 7.65039 19.0508 7.65039Z"
          fill={fillColor}
        />
      </svg>
    </span>
  );
};

export default ManageIcon;
